/**
 * Facts about this deployment, read once from the build environment.
 *
 * Kept out of api/client.ts and seo/head.ts so both can be imported by a test
 * without dragging the other's dependencies along.
 */

/**
 * The public origin of this site, without a trailing slash.
 *
 * Empty only under `npm run dev`: vite.config.ts refuses to build without
 * VITE_SITE_URL, and every consumer leaves its absolute URLs out rather than
 * inventing an origin.
 */
export const SITE_URL = (import.meta.env.VITE_SITE_URL?.trim() ?? "").replace(
  /\/+$/,
  "",
);
